const filterForm = {
  'name-placeholder': 'Name - Surname',
  'organization-placeholder': 'Organization',
  'code-placeholder': 'Employee Code',
  'date-placeholder': 'Date',
  'status-placeholder': 'Status',
  'leaveType-placeholder': 'Leave Type',
  organization: {
    placeholder: 'Oc Name..',
    label: 'Oc Name'
  },
  'employee-code': {
    placeholder: 'Employee Code..',
    label: 'Employee Code'
  },
  'name-surname': {
    placeholder: 'Name - Surname..',
    label: 'Name - Surname'
  },
  position: {
    placeholder: 'Position..',
    label: 'Position'
  },
  level: {
    placeholder: 'Level..',
    label: 'Level'
  },
  status: {
    placeholder: 'Status..',
    label: 'Status'
  },
  d: {
    placeholder: 'Date',
    label: 'Date'
  },
  date: {
    placeholder: {
      'start-date': 'Start Date..',
      'end-date': 'End Date..'
    },
    label: 'Date'
  },
  year: {
    placeholder: 'Year',
    label: 'Year'
  },
  'leave-status': {
    placeholder: 'Leave Status..',
    label: 'Leave Status'
  },
  'leave-type': {
    placeholder: 'Leave Type..',
    label: 'Leave Type'
  }
}

export default {
  title: 'E-Leave - Leave Report',
  exportForm: {
    exportType: {
      placeholder: 'Export Type',
      label: 'Export Type'
    },
    language: {
      en: 'EN',
      th: 'TH'
    }
  },
  buttons: {
    export: 'Export',
    refresh: 'Refresh'
  },
  messages: {
    retention:
      'Reports are kept for 24 hours and removed after your browser receives the download.',
    waitingFile:
      'Download your waiting report before creating another one, even if you change the report type or filters.',
    expiresAt: 'Available until {{date}}',
    cleanupPending:
      'The previous report is being removed. A new export will be available when cleanup completes.',
    cleanupFailed:
      'Your file was received, but cleanup could not be confirmed. Refresh to check its status.',
    selectExportType: 'Please select an export type.',
    submitFailed: 'Unable to start the export.',
    historyLoading: 'Loading reports...',
    historyEmpty: 'No reports yet. Click Export to create a report.',
    historyFailed: 'Unable to load reports. Click Refresh to try again.',
    downloadFailed: 'Unable to download the file.'
  },
  exportJob: {
    success: 'The report is ready to download.',
    queued: {
      title: 'Export queued',
      description: 'Your report is waiting to be processed.'
    },
    processing: {
      title: 'Exporting report',
      description: 'You can leave this page and return while it is processing.'
    },
    longRunning: {
      title: 'The export is taking longer than expected',
      description:
        'Processing is still active. You can return to this page later.'
    },
    failed: {
      title: 'Export failed',
      description: 'The report could not be generated. Please try again.'
    },
    'tracking-error': {
      title: 'Unable to track the export',
      description: 'Refresh the history to check whether the report completed.'
    }
  },
  history: {
    table: {
      createdAt: 'Date',
      fileName: 'File name',
      fileUuid: 'File UUID',
      url: 'Download'
    }
  },
  tabs: {
    'leave-report-transaction': 'Transaction Leave Report',
    'leave-report-summary': 'Summary Leave Report'
  },
  'leave-report-transaction': {
    'filter-form': {
      ...filterForm
    },
    table: {
      'employee-code': 'Employee Code',
      employee: 'Employee Detail',
      leaveTypeName: 'Leave Type',
      duration: 'Leave Duration',
      day: 'No. of Days',
      reason: 'Reason',
      status: 'Status',
      approval: 'Approval Persons',
      create: 'Create Date',
      approveDate: 'Approve Date'
    }
  },
  'leave-report-summary': {
    'filter-form': {
      ...filterForm
    },
    table: {
      'employee-code': 'Employee Code',
      employee: 'Employee Detail',
      'employee-status': 'Employee Status',
      'leave-type': 'Leave Type',
      hire: 'Hire Date',
      balance: 'Balance',
      total: 'Total',
      entitlement: 'Entitlement',
      used: 'Used',
      carried: 'Carried Over'
    }
  }
}
